import { useEffect, useState } from "react";
import { Download, Loader2, Search } from "lucide-react";
import { toast } from "sonner";
import { adminApi, eur } from "../../lib/api";

export const CustomersPanel = ({ onShowOrders }) => {
  const [q, setQ] = useState("");
  const [list, setList] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      adminApi.customers(q).then((d) => setList(Array.isArray(d) ? d : [])).catch(() => { setList([]); toast.error("No se pudieron cargar los clientes"); });
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  const download = async () => {
    try {
      const blob = await adminApi.customersCsv(q);
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `clientes-jungle-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch { toast.error("No se pudo descargar la lista"); }
  };

  return (
    <section data-testid="customers-panel" className="mt-5">
      <div className="flex flex-wrap gap-2">
        <label className="flex-1 min-w-[220px] relative">
          <span className="sr-only">Buscar clientes</span>
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#C9D6C2]" />
          <input data-testid="customers-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nombre, email, DNI, teléfono o ciudad"
            className="w-full h-11 rounded-full bg-[#143823] border border-[#F6EEDC]/25 pl-9 pr-4 text-sm outline-none focus:border-[#F2B441]" />
        </label>
        <button type="button" onClick={download} data-testid="customers-download" className="h-11 px-5 rounded-full bg-[#8CD05A] text-[#0E2A1C] font-semibold text-sm inline-flex items-center gap-2 hover:bg-[#F2B441] transition-colors">
          <Download className="w-4 h-4" /> Descargar Excel
        </button>
      </div>
      {list === null ? <Loader2 className="w-6 h-6 animate-spin text-[#8CD05A] mt-8" /> : (
        <>
          <p data-testid="customers-count" className="text-sm text-[#C9D6C2] mt-4">{list.length} clientes</p>
          {list.length === 0 && <p data-testid="customers-empty" className="text-[#C9D6C2] py-8">No hay clientes{q ? " con esa búsqueda" : " registrados todavía"}.</p>}
          <div className="mt-3 space-y-2">
            {list.map((c) => (
              <article key={c.id} data-testid={`customer-${c.id}`} className="rounded-[14px] border border-[#8CD05A]/20 bg-[#0E2A1C] p-4 grid sm:grid-cols-[1fr_auto] gap-3 text-sm">
                <div className="space-y-0.5">
                  <p className="font-semibold text-base">{c.name} <span className="font-mono-d text-xs text-[#C9D6C2]">· {c.dni}</span></p>
                  <p className="text-[#E3EADF] break-all">{c.email} · {c.phone}</p>
                  <p className="text-[#C9D6C2]">{c.line1}, {c.postal_code} {c.city} ({c.state})</p>
                  <p className="text-xs text-[#C9D6C2]">Alta: {c.created_at ? new Date(c.created_at).toLocaleDateString("es-ES") : "—"}</p>
                </div>
                <div className="sm:text-right flex sm:flex-col items-center sm:items-end justify-between gap-2">
                  <span><span className="font-mono-d">{eur(c.spent || 0)}</span> <span className="text-xs text-[#C9D6C2]">· {c.orders} pedidos</span></span>
                  <button type="button" onClick={() => onShowOrders(c)} disabled={!c.orders} data-testid={`customer-orders-${c.id}`}
                    className="h-9 px-4 rounded-full border border-[#F6EEDC]/25 text-xs hover:border-[#F2B441] disabled:opacity-40">Ver pedidos</button>
                </div>
              </article>
            ))}
          </div>
        </>
      )}
    </section>
  );
};
